// oxlint-disable-next-line no-restricted-imports -- This is the centralized axios instance
import axios from "axios";
import type { AxiosInstance } from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    /** Skip the 401 session-recovery interceptor for this request. */
    skipAuthRecovery?: boolean;
    /** Internal flag: this request is a retry after a successful token refresh. */
    __authRecoveryRetried?: boolean;
  }
}

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL?.replace(/\/$/, "") || "";

const api: AxiosInstance = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

export default api;
